import { styled } from '@mui/material/styles';
import { TableContainer, Table, TableRow, TableCell } from '@mui/material';

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  [theme.breakpoints.down('md')]: {
    boxShadow: 'none',
  },
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  minWidth: 650,
}));

export const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 600,
  backgroundColor: '#e4e4e4',
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover':{
    backgroundColor: '#e4e4e4',
  }
}));
